import React, { Component } from "react";

import Element from "./Element";
import Arrow from "./Arrow";
import ArrowCorner from "./ArrowCorner";

import "../styles/legend.scss";

class Legend extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="legend">
        <div className="center legend--content">
          <div className="legend--content--examplePure">
            <div className="legend--content--exampleElement">
              <Element atomicNumber={46} symbol="Pd" big />
            </div>
            <div className="legend--content--examplePure--text">
              Atomic number
              <Arrow direction="right" length={6.8} x="-7.8vw" y="2.2vw" />
              <br />
              Symbol <Arrow direction="right" length={5} x="-6vw" y="0.5vw" />
            </div>
          </div>
          <div className="legend--content--exampleOther">
            <div className="legend--content--exampleElement">
              <Element
                atomicNumber={5}
                symbol="B"
                pure
                big
                tellurium
                other
                fluorine
                nitrogen
                oxygen
                sulfur
                selenium
              />
              <ArrowCorner
                direction="downRight"
                lengths={[1.5, 10.5]}
                x="1vw"
                y="0vw"
              />
            </div>
            <div className="legend--content--exampleOther--text">
              The pure element has been grown
              <ArrowCorner
                direction="leftDown"
                lengths={[6, 6]}
                x="12vw"
                y="8vw"
              />
            </div>
          </div>
          <ul className="legend--content--list">
            <li>
              <div className="legend--content--list--item legend--content--list--item--tellurium" />
              Compounds with Te
            </li>
            <li>
              <div className="legend--content--list--item legend--content--list--item--fluorine" />
              Compounds with F
            </li>
            <li>
              <div className="legend--content--list--item legend--content--list--item--nitrogen" />
              Compounds with N
            </li>
            <li>
              <div className="legend--content--list--item legend--content--list--item--oxygen" />
              Compounds with O
            </li>
            <li>
              <div className="legend--content--list--item legend--content--list--item--sulfur" />
              Compounds with S
            </li>
            <li>
              <div className="legend--content--list--item legend--content--list--item--selenium" />
              Compounds with Se
            </li>
            <li>
              <div className="legend--content--list--item legend--content--list--item--other" />
              Compounds with
            </li>
            <li>
              <div className="legend--content--list--item " />
              other elements
            </li>
          </ul>
          {this.props.filterYear !== 0 && (
            <div className="legend--content--filterYear">
              {this.props.filterYear}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Legend;
